import {useEffect,useState} from 'react';
import {MIXED_SPORTS,readMixedStorage} from './mixedMatchData';

export default function useMixedMatches(date) {
  const [data,setData]=useState({date:null,games:[],failures:[],pending:[],loading:true});
  const [favorites,setFavorites]=useState({});
  const [revision,setRevision]=useState(0);
  const [protectionVersion,setProtectionVersion]=useState(0);
  useEffect(()=>{
    const changed=()=>setProtectionVersion(value=>value+1);
    window.addEventListener('sports-hq-push-state',changed);
    window.addEventListener('storage',changed);
    return ()=>{window.removeEventListener('sports-hq-push-state',changed);window.removeEventListener('storage',changed);};
  },[]);
  useEffect(()=>{
    let active=true;
    const controller=new AbortController(), account={};
    const sync=()=>{
      const next={};
      for(const sport of MIXED_SPORTS){
        const saved=readMixedStorage(`${sport.id}-hq-favorite-teams`,[]);
        next[sport.id]=[...new Set([...(account[sport.id] || []),...(Array.isArray(saved)?saved:[])])];
      }
      if(active)setFavorites(next);
    };
    const refresh=async()=>{
      sync();
      await Promise.allSettled(MIXED_SPORTS.filter(s=>!window.SportsHQSettings && s.id!=='football').map(async sport=>{
        const response=await fetch(`/${sport.id}/api/sportsim/favorite-teams`,{signal:controller.signal,cache:'no-store'});
        if(!response.ok)return;
        const value=await response.json(), ids=value.team_ids || value.team_names;
        account[sport.id]=value.authenticated && Array.isArray(ids)?ids:[];
      })); sync();
    };
    const visible=()=>{if(!document.hidden)refresh();};
    refresh();
    window.addEventListener('sports-hq-settings-state',sync);window.addEventListener('sports-hq-follows-change',sync);window.addEventListener('storage',sync); document.addEventListener('visibilitychange',visible);
    return ()=>{active=false;controller.abort();window.removeEventListener('sports-hq-settings-state',sync);window.removeEventListener('sports-hq-follows-change',sync);window.removeEventListener('storage',sync);document.removeEventListener('visibilitychange',visible);};
  },[]);
  useEffect(()=>{
    let active=true, controller, retryTimer, generation=0;
    const load=async(background=false,fresh=false)=>{
      const version=++generation;controller?.abort();clearTimeout(retryTimer);
      controller=new AbortController();const requestController=controller;
      setData(old=>({date,games:background && old.date===date?old.games:[],failures:[],pending:[],loading:true}));
      const timeout=setTimeout(()=>requestController.abort(),20000);
      let refreshing=false;
      await Promise.allSettled(MIXED_SPORTS.map(async sport=>{
        try{
          const response=await fetch(`${sport.api}/matches?date=${date}${fresh?"&fresh=true&verify=true":""}`,{signal:requestController.signal,cache:fresh?"no-store":"default"});
          if(!response.ok)throw Error();
          const body=await response.json();if(!Array.isArray(body.matches))throw Error();
          if(!active || version!==generation)return;
          const seen=new Set();
          const games=body.matches.filter(game=>{const key=game.id ?? game.match_link;if(seen.has(key))return false;seen.add(key);return true;}).map(game=>({...game,sport}));
          refreshing ||= Boolean(body.refreshing);
          setData(old=>({...old,games:[...old.games.filter(game=>game.sport.id!==sport.id),...games],pending:body.refreshing?[...old.pending,sport.label]:old.pending}));
        }catch{
          if(active && version===generation)setData(old=>({...old,games:old.games.filter(game=>game.sport.id!==sport.id),failures:[...old.failures,sport.label]}));
        }
      }));
      clearTimeout(timeout);
      if(!active || version!==generation)return;
      setData(old=>({...old,loading:false}));
      if(refreshing && !document.hidden)retryTimer=setTimeout(()=>load(true),5000);
    };
    const visible=()=>{if(!document.hidden)load(true);};
    let fresh=false;
    try {fresh=sessionStorage.getItem('sports-hq-mixed-force-refresh')==='1';sessionStorage.removeItem('sports-hq-mixed-force-refresh');} catch {}
    load(false,fresh);const interval=setInterval(visible,60000);
    document.addEventListener('visibilitychange',visible);
    return ()=>{active=false;controller?.abort();clearTimeout(retryTimer);clearInterval(interval);document.removeEventListener('visibilitychange',visible);};
  },[date,revision]);
  return {...data,games:data.date===date?data.games:[],favorites,protectionVersion,retry:()=>setRevision(value=>value+1)};
}
